import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";

const breadcrumbsStatic = [{
	name: 'Forms',
	url: '/forms',
	icon: 'dashboard',
}];

export default class Computer_Repair_Waiver extends Framework.Components.View {

	render() {
		let {match, baseUrl} = this.props

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: "Computer Repair Waiver",
				url: `/forms/computer_repair_waiver`,
				icon: 'book',
			}
		]);
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>
				<Objects.ComputerRepairWaiver
					id={match.params.id}
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					updateName={this.updateName}
					baseUrl={baseUrl}
					goBack={true}
				/>
			</div>
		);
	}
}

